// Mirrors CandidateSearch::OpenSearch::ApplicationsSearcher::MAX_RESULT_WINDOW (Ruby).
// OpenSearch rejects queries where from + size exceeds this bound; the server
// clamps `from` to match. Capping totalRows in the pager keeps UI state in
// sync so users can't navigate to pages the backend would clamp. GREEN-67215.
export const OPENSEARCH_MAX_RESULT_WINDOW = 10_000;
